import i18next from "i18next";
import { useState, useEffectWithoutCleanup } from "Shared/haunted/CustomHooks";
import { HauntedFunc } from "Shared/haunted/HooksHelpers";
import { PUB_SUBS } from "Services/pub-sub-service/PubSub";
import { unsafeHTML } from "lit-html/directives/unsafe-html";
import { createAmericanAirlinesLoginUrl } from "Services/urls";
import { iconButton } from "Components/iconButton";
import { html } from "lit-html";

export const name = "ac-redemption-no-promo-code-modal";
export const useShadowDOM = false;

export const observedAttributes: (keyof Attributes)[] = ["culture"];

export interface Attributes {
	culture: string;
}

export interface Props {
	culture: string;
}

export const Component: HauntedFunc<Props> = (host) => {
	const props: Props = {
		culture: host.culture,
	};

	const [isOpen, setIsOpen] = useState(false);

	const init = () => {
		const handler = PUB_SUBS.RedemptionNoPromoCodeModalOpened.subscribe(() => {
			setIsOpen(true);
		});

		return () => handler.unsubscribe();
	};

	useEffectWithoutCleanup(init, []);

	const handleContinueButton = () => {
		setIsOpen(false);
		window.location.href = createAmericanAirlinesLoginUrl(props.culture);
	};

	const handleClose = () => setIsOpen(false);

	const continueButton = iconButton({
		isAction: true,
		icon: html`<i class="jsh-circle-chevron-right1 text-base"></i>`,
		label: i18next.t("Continuar"),
		onClick: handleContinueButton,
	});

	const headerTemplate = () => html`
		<div class="flex h-20 w-full items-center justify-start bg-brand-primary p-5 text-white">
			<i class="jsh-icon jsh-triangle-exclamation-thick mr-5 text-[36px]"></i>
			<span class="text-center text-[24px] font-bold">${i18next.t("Important")}!</span>
		</div>
	`;

	return isOpen
		? html`
				<div class="fixed inset-0 z-[100001] bg-n-blue/75 backdrop-blur-xs">
					<div
						class="absolute !w-[550px] max-w-[95%] overflow-hidden rounded-2xl bg-white all-center sm:w-auto"
						data-test-id="modal-content"
					>
						<div
							class="absolute right-3 top-3 z-10 flex h-7 w-7 cursor-pointer items-center justify-center rounded-full bg-[rgba(51,84,109,0.7)] pb-0.5 pl-px text-[22px] font-semibold leading-none text-white sm:right-3 sm:top-3 sm:h-8 sm:w-8 sm:pl-px sm:text-[26px]"
							data-test-id="modal-close-button"
							@click=${handleClose}
						>
							&times;
						</div>
						${headerTemplate()}
						<div class="modal-body">
							<div class="px-6 pt-5 text-center font-body leading-snug text-be-blue-2">
								${unsafeHTML(
									i18next.t("RedemptionNoPromoModalText {{-reg}}", {
										reg: '<span class="relative font-body top-[-1px]">&reg;</span>',
									})
								)}
							</div>
						</div>
						<div class="flex w-full flex-col items-center p-6">
							${continueButton.htmlTemplate()}
							<span
								class="text-medium md:text-medium mt-3 cursor-pointer select-none text-center text-n-blue underline hover:no-underline sm:text-base"
								@click=${handleClose}
							>
								${i18next.t("Choose another flight")}
							</span>
						</div>
					</div>
				</div>
			`
		: html``;
};
